module.exports = __webpack_public_path__ + "img/loading.cac6f4f6.gif";